import React from 'react';
import '@ant-design/v5-patch-for-react-19' ; 

/* WithInfo Screen */
import WithInfoTop from './WithInfoTop';
import WithInfoLogin from './WithInfoLogin';
import WithInfoLNB from './WithInfoLNB';
import WithInfoContents from './WithInfoContents';
import WithInfoMsgModal from 'pages/components/WithInfoMsgModal';
import WithComPopup from 'pages/components/WithComPopup';
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { FrameAction } from '../../../redux/slice/frame/root_main_slice';
import { Layout, Modal, Spin } from 'antd';
import { useNavigate, useLocation, useNavigationType  } from "react-router";
import * as common from 'libs/common';

export let openPopup:any;
export let closeAllPopup:any;

const WithInfoMain: React.FC = () => {
    const [popupItems, setPopupItems] = React.useState([] as any);
    const lnbCollapsed    = useAppSelector((state) => state.Frame.lnbCollapsed);
    const jwtToken        = useAppSelector((state) => state.Frame.jwtToken);
    const activeKey       = useAppSelector((state) => state.Frame.activeKey);
    const showLoading     = useAppSelector((state) => state.Frame.showLoading);
    const topMenuItems    = useAppSelector((state) => state.Frame.topMenuItems);
    const lnbMenuItems    = useAppSelector((state) => state.Frame.lnbMenuItems);
    const allLnbMenuItems = useAppSelector((state) => state.Frame.allLnbMenuItems);
    const msgItem         = useAppSelector((state) => state.Frame.msgItem);

    const dispatch     = useAppDispatch();
    const navigate     = useNavigate();
    const location     = useLocation();
    const navigationType = useNavigationType();

    const defaultMenu = 'MCOM2021006';  // MCOM2021006

    React.useEffect(() => {
        if (activeKey) {
            if (navigationType !== 'POP') {
                navigate(`/${activeKey}`, { replace: false });
            } else {
                navigate(`/${activeKey}`, { replace: true });
            }
            
            if (lnbMenuItems) {
                const selectedMenu:any = allLnbMenuItems.filter((item:any) => {
                    return item.key === activeKey;
                })[0];
                const selectedTopMenu:any = topMenuItems.filter((item:any) => {
                    return item.menuId === selectedMenu.upperMenuId;
                })[0];
        
                if (selectedTopMenu) {
                    dispatch(FrameAction.setCurrentTopMenuKey(selectedTopMenu.menuId));
                }

                if (selectedMenu) {
                    localStorage.setItem('scrnId', selectedMenu.pgmId);
                }
            }
        }
    }, [activeKey, topMenuItems, allLnbMenuItems, dispatch]);
    
    React.useEffect(() => {
        if (!jwtToken) {
            return;
        }
        let arrNav:any = [];
        if (location.pathname !== '/') {
            arrNav.push(location.pathname.substring(1));
            dispatch(FrameAction.setMdiItems(arrNav as []));
            dispatch(FrameAction.setActiveKey(location.pathname.substring(1)));

            if (!lnbMenuItems || lnbMenuItems.length < 1) {
                const currLnbMenuItem:any = allLnbMenuItems.filter((lnb:any) =>{
                    return lnb.key === location.pathname.substring(1);
                })[0];
                const currTopMenuItem:any = allLnbMenuItems.filter((item:any) => {
                    return item.menuId === currLnbMenuItem.upperMenuId;
                })[0];
                const currLnbMenuItems = allLnbMenuItems.filter((lnb:any) =>{
                    return lnb.upperMenuId === currTopMenuItem.menuId && lnb.key !== 'MCOM2021008';
                });

                dispatch(FrameAction.setCurrentTopMenuKey(currTopMenuItem.menuId));
                dispatch(FrameAction.setLnbMenuItems(currLnbMenuItems as []));
                dispatch(FrameAction.setActiveKey(currLnbMenuItem.key));
            }
        } else {
            const currLnbMenuItems:any = allLnbMenuItems.filter((lnb:any) =>{
                return lnb.upperMenuId === 'MCOM2021005' && lnb.key !== 'MCOM2021008';
            });
            
            dispatch(FrameAction.setCurrentTopMenuKey('MCOM2021005'));
            dispatch(FrameAction.setLnbMenuItems(currLnbMenuItems));
            dispatch(FrameAction.setActiveKey(defaultMenu));
            navigate('/' + defaultMenu, { replace: false });
        }
    }, [location]);

    React.useEffect(() => {
        const loadStyles = async () => {
            await import('../../../index.css');
        };
      
        loadStyles();

        const handleStorageChange = (e:any) => {
            if (!localStorage.getItem('jwtToken')) {
                dispatch(FrameAction.setJwtToken(''));
            }
        };

        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    openPopup = (params:any) => {
        const arr : any[] = [...popupItems];
        const exists : any[] = arr.filter((item:any) => {
            return params.popupId === item.popupId;
        });
        if (exists && exists.length > 0) {
            const msg = {
                title : '위드정보 확인',
                contents: '이미 열려있는 팝업 입니다.',
            };
            common.openInfo(msg);
        } else {
            arr.push(params);
            setPopupItems(arr);
        }

    }

    closeAllPopup = () => {
        setPopupItems([]);
    }

    const popupProps = React.useCallback((popupId:string) => {
        const popupProps = popupItems.filter((item:any) => {
            return item.popupId === popupId;
        })[0];

        const close = () => {
            let rtnArr;
            const tempArr = [...popupItems];
            const idx = tempArr.findIndex((item:any) => {
                return item.popupId === popupId;
            });
            const curr = tempArr.filter((item:any) => {
                return item.popupId === popupId;
            })[0];
            if(idx === 0){
                rtnArr = tempArr.slice(idx + 1, popupProps.length);
            }else{
                rtnArr = tempArr.slice(0, idx);
                rtnArr = rtnArr.concat(tempArr.slice(idx + 1, tempArr.length));
            }

            localStorage.setItem('scrnId', curr.openerId);

            setPopupItems(rtnArr);
        }

        const accept = (data:any) => {
            if (popupProps.accept && typeof popupProps.accept === 'function') {
                popupProps.accept(data);
                close();
            } else {
                close();
            }
        }
        const cancel = () => {
            if (popupProps.cancel && typeof popupProps.cancel === 'function') {
                popupProps.cancel();
                close();
            }
            close();
        }
        return {...popupProps, accept, cancel};
    }, [popupItems]);


    const msgProps = React.useCallback(() => {
        return {...msgItem};
    }, [msgItem]);

    const contentStyle = {
        padding: 50,
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 4,
    };

    return (
        <Layout>
            {popupItems && popupItems.length > 0 ? 
                popupItems.map((item:any, idx:number) => {
                    const key = item.popupId;
                    return (
                        <WithComPopup key={key} {...popupProps(key)}/>
                    )})
                : null
            }
            <WithInfoMsgModal {...msgProps()}/>
            <Modal open={showLoading} footer={null} maskClosable={false} closable={false} style={{ display: "flex", justifyContent: "center", alignItems: "center", height : '80%' }} zIndex={9999}>
                <Spin size="large" tip="Loading..."><div style={contentStyle} /></Spin>
            </Modal> 
            {jwtToken ?
            <>
                <WithInfoTop/>
                <Layout id="screenHeight" className='main-layout-background' style={{ maxHeight: '100%', minWidth: '100%' }}>
                    {!lnbCollapsed ? <WithInfoLNB style={{ minHeight: '100%' }}/> : null}
                    <WithInfoContents/>
                </Layout>
            </>
            :
            <WithInfoLogin/>}
        </Layout>    
    );

}

export default WithInfoMain;